import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { CarouselModule } from "ngx-owl-carousel-o";
import { OwlOptions } from "ngx-owl-carousel-o";
import { AnalyticsService } from "src/app/services/analytics/analytics.service";

@Component({
  selector: "app-projects",
  templateUrl: "./projects.component.html",
  styleUrls: ["./projects.component.scss"],
  standalone: true,
  imports: [CommonModule, TranslateModule, CarouselModule],
})
export class ProjectsComponent implements OnInit {
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    navSpeed: 700,
    items: 1,
    autoplay: true,
    autoplayTimeout: 3000,
  };

  @ViewChild("carouselRef", { static: false })
  carouselRef: ElementRef;

  constructor(public analyticsService: AnalyticsService) {}

  ngOnInit(): void {}
}
